import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';

@Component({
  selector: 'app-modal-yes-no',
  templateUrl: './modal-yes-no.component.html',
  styles: []
})
export class ModalYesNoComponent extends ExcTranslation implements OnInit {

  constructor(private overlayConfig: OverlayConfig, private overlayRef: OverlayRef) {
    super();
  }
  proceed(answer) {
    this.overlayRef.close({proceed: answer});
  }
  ngOnInit() {
  }

}
